import { CURRENT_DISTANCE_DATA } from './currentDistanceData';
import CurrentSource from '../../../../resources/images/alerts_visualizer_images/current_source.png';
import CurrentFirstAlertImage from '../../../../resources/images/alerts_visualizer_images/current_first_alert.png';
import CurrentMaxAlertImage from '../../../../resources/images/alerts_visualizer_images/current_max_alert.png';
import AlertDistanceVisualizerBase from './AlertDistanceVisualizerBase';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '@/resources/strings/StringKeys';
import type { SxProps, Theme } from '@mui/material';

const DEFAULT_CURRENT_TYPE = '10A RMS';

interface CurrentDistanceVisualizerProps {
  initialType?: string;
  initialSensitivity?: number;
  hoveredRange?: string;
  hoveredSensitivity?: number;
  sx?: SxProps<Theme>;
}

export default function CurrentDistanceVisualizer({
  initialType = DEFAULT_CURRENT_TYPE,
  initialSensitivity = 8,
  hoveredRange,
  hoveredSensitivity,
  sx,
}: CurrentDistanceVisualizerProps) {
  const { t } = useTranslation();

  return (
    <AlertDistanceVisualizerBase
      variant="current"
      title={t(StringKeys.CURRENT_ALERTS_VISUALIZER)}
      description={t(StringKeys.CURRENT_ALERTS_VISUALIZER_DESCRIPTION)}
      alertColor="#556780"
      sourceImage={CurrentSource}
      firstAlertImage={CurrentFirstAlertImage}
      maxAlertImage={CurrentMaxAlertImage}
      dataSource={CURRENT_DISTANCE_DATA}
      initialType={initialType}
      initialSensitivity={initialSensitivity}
      hoveredRange={hoveredRange}
      hoveredSensitivity={hoveredSensitivity}
      sx={sx}
    />
  );
}
